<template>
  <div class="header-logo">
    <div class="graphic">
      <div class="logo" :class="{ transitioning: !showLogo }">
        <div class="pngs">
          <img class="logo-blur-1" src="/figures/logo-blur-1.png" />
          <img class="logo-blur-2" src="/figures/logo-blur-2.png" />
          <img class="logo-base" src="../assets/c-logo-gradient.png" />
        </div>
      </div>
      <Electricity />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Electricity from "./Electricity.vue";

export default {
  name: "HeaderLogo",
  components: {
    Electricity,
  },
  props: {},
  data() {
    return {
      videoLoaded: false,
      videoRef: null,
      showLogo: true,
      activeSrc:
        "https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.webm#t=0.001",
    };
  },
  computed: {
    ...mapState(["transitioning", "transitioningBack"]),
    inCareering() {
      return this.$route.path.includes("/careering") ? true : false;
    },
    inRole() {
      // Split the current route into segments
      const pathSegments = this.$route.path.split("/");
      // Check if the first segment is 'careering' and there is a second segment
      if (pathSegments.length > 2) {
        console.log(pathSegments);
        return pathSegments[1] === "careering" && pathSegments[2] !== "";
      }
      return false;
    },
  },
  watch: {
    "$store.state.transitioning"(newVal) {
      if (newVal) {
        this.showLogo = false;

        setTimeout(() => {
          this.$store.commit("setTransitioning", false);
          this.showLogo = true;
        }, 1000);
      }
    },
    "$store.state.transitioningBack"(newVal) {
      if (newVal) {
        this.showLogo = false;

        setTimeout(() => {
          this.$store.commit("setTransitioningBack", false);
          this.showLogo = true;
        }, 750);
      }
    },
  },
  methods: {},
  mounted() {},
};
</script>

<style scoped>
.header-logo {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.graphic {
  margin-top: 10rem;
  height: 200px;
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.logo {
  position: relative;
  opacity: 1;
  transform: scale(1);
  z-index: 1;
  /* entering logo transition */
  transition: transform 600ms cubic-bezier(0.32, 0.3, 0.1, 0.95),
    opacity 600ms cubic-bezier(0.31, -0.02, 0.32, 0.97);
}

.logo .pngs {
  display: flex;
  display: column;
  align-items: center;
  justify-content: center;
  height: 64px;
  position: relative;
}

.logo .pngs img {
  position: absolute;
  height: 100%;
  width: auto;
}

.logo .pngs .logo-blur-1 {
  opacity: 0.65;
  transform: scale(2);
}

.logo .pngs .logo-blur-2 {
  opacity: 0.65;
  transform: scale(2);
  transform-origin: center center;
}

.logo.transitioning {
  opacity: 0;
  transform: scale(0);
  /* leaving logo transition */
  transition: transform 400ms cubic-bezier(0.67, 0.19, 0.37, 0.75),
    opacity 350ms cubic-bezier(0.67, 0.19, 0.37, 0.75);

  /* The cartoony version */
  /* transition: transform 400ms cubic-bezier(1, -1.08, 0.37, 0.75),
    opacity 350ms cubic-bezier(1, -1.08, 0.37, 0.75); */
}

.logo svg {
  height: 100%;
  width: 100%;
}

.electricity {
  position: absolute;
  z-index: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

@media screen and (max-width: 600px) {
  .graphic {
    margin-top: 2rem;
  }
}
</style>
